import { create } from "zustand";
import { useDebounce } from "@/hooks/useDebounce";

interface SearchState {
  search: string;
  setSearch: (search: string) => void;
}

export const useSearchStore = create<SearchState>((set) => ({
  search: "",
  setSearch: (search: string) => set({ search }),
}));

export const useGlobalSearch = (debounceMs: number = 200) => {
  const { search, setSearch } = useSearchStore();
  const debouncedSearch = useDebounce(search, debounceMs);

  return {
    search,
    debouncedSearch,
    setSearch,
  };
};
